import { Apis } from "../../../lib/Apis";

const getApiError = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export const tentativeCost = () => {
  const getTentativeCost = async (setTentaiveCostData) => {
    try {
      const response = await Apis.getTentativeCost();
      const payload = response?.data?.data ?? response?.data;
      const costData = payload?.costData || (Array.isArray(payload) ? payload : []);
      const first = costData[0] || {};
      if (setTentaiveCostData) setTentaiveCostData(first);
      return costData;
    } catch (error) {
      console.error(error);
      throw new Error(getApiError(error, "Failed to fetch tentative cost."));
    }
  };

  const addOrUpdateTentativeCost = async (data) => {
    try {
      const response = await Apis.addOrUpdateTentativeCost(data);
      const body = response?.data;
      if (body?.success === false) {
        throw new Error(body?.message || "Failed to save tentative cost.");
      }
      return body;
    } catch (error) {
      console.error(error);
      throw new Error(getApiError(error, "Failed to save tentative cost."));
    }
  };

  return {
    getTentativeCost,
    addOrUpdateTentativeCost,
  };
};
